import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { UserPrivilegeEnum } from '../../../../enums/rights/user-privilege.enum';
import { ResetStateDefaults } from '../../../base-action-class.model';
import { RCommunity } from './r-community.action';
import featureFlags from '../../../../feature-flags';

interface RCommunityXsStateModel {
  canAccessAllCommunities: string;
  createCommunityFunction: string;
}

const getDefaults = (): RCommunityXsStateModel => ({
  canAccessAllCommunities: null,
  createCommunityFunction: null
});

@State<RCommunityXsStateModel>({
  name: 'rCommunity',
  defaults: getDefaults()
})
@Injectable()
export class RCommunityXsState {

  //region SELECTOR

  @Selector()
  static canAccessAllCommunities(state: RCommunityXsStateModel): boolean {
    return state.canAccessAllCommunities != null;
  }

  @Selector()
  static canCreateCommunity(state: RCommunityXsStateModel): boolean {
    return state.createCommunityFunction != null;
  }

  //endregion

  //region ACTIONS
  @Action(RCommunity.SetCommunityPrivileges)
  public setCommunityPrivileges(ctx: StateContext<RCommunityXsStateModel>, action: RCommunity.SetCommunityPrivileges) {
    const state = ctx.getState();
    const communityPrivileges = [...action.activeUserRightInfoDtoModel.communityPrivileges];

    //find user privilege data model
    const canAccessAllCommunities = communityPrivileges.find(id => id === UserPrivilegeEnum.ACCESS_ALL_COMMUNITIES);
    const createCommunityFunction = communityPrivileges.find(id => id === UserPrivilegeEnum.CREATE_COMMUNITY);

    //set the state
    ctx.setState({
      ...state,
      canAccessAllCommunities: canAccessAllCommunities,
      createCommunityFunction: featureFlags.CREATE_COMMUNITY_ENABLED ? createCommunityFunction : null
    });
  }

  @Action(ResetStateDefaults)
  public resetDefaults(ctx: StateContext<RCommunityXsStateModel>): void {
    ctx.setState({ ...getDefaults() });
  }

  //endregion
}
